


export const Loading = (props) => {
    return (
        <div className={`loader ${props.show ? 'active' : ''}`}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
        </div>
    )
}